export const overviewRoute = {
    path: '/home',
    name: '工作台',
    code: 'Overview',
    component: './Overview',
  };

export const homeRoute = {
    path: '/',
    name: '首页',
    hideInMenu: true,
    component: './Home',
  };
